import store from '../../../store';

export default async (to, from, next) => {
    if (store.getters['currentAffiliateLogo'] && store.getters['currentAffiliateNumber']) {
        next();
    } else {
        
        next();
    }
}